export default __webpack_public_path__ + "static/media/tutorial_preview_python_wrapper.1790c61c.png";